import { render, staticRenderFns } from "./EventCardSmall.vue?vue&type=template&id=678128ae&scoped=true"
import script from "./EventCardSmall.vue?vue&type=script&lang=js"
export * from "./EventCardSmall.vue?vue&type=script&lang=js"
import style0 from "./EventCardSmall.vue?vue&type=style&index=0&id=678128ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678128ae",
  null
  
)

export default component.exports